(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



// stage content:
(lib.Ribbon_Animation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [60];
	// timeline functions:
	this.frame_60 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(60).call(this.frame_60).wait(1));

	// orangemask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_50 = new cjs.Graphics().p("EADcBmqMAAAgu4MAiEAAAMAAAAu4g");
	var mask_graphics_51 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_graphics_52 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_graphics_53 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_graphics_54 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_graphics_55 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_graphics_56 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_graphics_57 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_graphics_58 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_graphics_59 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_graphics_60 = new cjs.Graphics().p("EgM9BmqMAAAgu4MAiDAAAMAAAAu4g");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:null,x:0,y:0}).wait(50).to({graphics:mask_graphics_50,x:240.025,y:657.05}).wait(1).to({graphics:mask_graphics_51,x:350.025,y:1164.075}).wait(1).to({graphics:mask_graphics_52,x:329.025,y:1164.075}).wait(1).to({graphics:mask_graphics_53,x:308.025,y:1164.075}).wait(1).to({graphics:mask_graphics_54,x:287.025,y:1164.075}).wait(1).to({graphics:mask_graphics_55,x:266.025,y:1164.075}).wait(1).to({graphics:mask_graphics_56,x:245.025,y:1164.075}).wait(1).to({graphics:mask_graphics_57,x:224.025,y:1164.075}).wait(1).to({graphics:mask_graphics_58,x:203.025,y:1164.075}).wait(1).to({graphics:mask_graphics_59,x:182.025,y:1164.075}).wait(1).to({graphics:mask_graphics_60,x:135.025,y:657.05}).wait(1));

	// Orange
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F2AD6E").s().p("AvyJCIfl/fIAANfI/lfdg");
	this.shape.setTransform(157.225,1162.1);
	this.shape._off = true;

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(50).to({_off:false},0).wait(11));

	// yellowmask (mask)
	var mask_1 = new cjs.Shape();
	mask_1._off = true;
	var mask_1_graphics_40 = new cjs.Graphics().p("EgRBBWkMAAAgu4MAiDAAAMAAAAu4g");
	var mask_1_graphics_41 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_1_graphics_42 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_1_graphics_43 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_1_graphics_44 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_1_graphics_45 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_1_graphics_46 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_1_graphics_47 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_1_graphics_48 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_1_graphics_49 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_1_graphics_50 = new cjs.Graphics().p("EgNHBWkMAAAgu4MAiDAAAMAAAAu4g");

	this.timeline.addTween(cjs.Tween.get(mask_1).to({graphics:null,x:0,y:0}).wait(40).to({graphics:mask_1_graphics_40,x:-56.975,y:554.05}).wait(1).to({graphics:mask_1_graphics_41,x:-35.375,y:958.075}).wait(1).to({graphics:mask_1_graphics_42,x:-13.775,y:958.075}).wait(1).to({graphics:mask_1_graphics_43,x:7.825,y:958.075}).wait(1).to({graphics:mask_1_graphics_44,x:29.425,y:958.075}).wait(1).to({graphics:mask_1_graphics_45,x:51.025,y:958.075}).wait(1).to({graphics:mask_1_graphics_46,x:72.625,y:958.075}).wait(1).to({graphics:mask_1_graphics_47,x:94.225,y:958.075}).wait(1).to({graphics:mask_1_graphics_48,x:115.825,y:958.075}).wait(1).to({graphics:mask_1_graphics_49,x:137.425,y:958.075}).wait(1).to({graphics:mask_1_graphics_50,x:134.025,y:554.05}).wait(11));

	// Yellow
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#F8DA77").s().p("AvypCIAAtgIflflIAANgg");
	this.shape_1.setTransform(157.175,959.575);
	this.shape_1._off = true;

	var maskedShapeInstanceList = [this.shape_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(40).to({_off:false},0).wait(21));

	// purplemask (mask)
	var mask_2 = new cjs.Shape();
	mask_2._off = true;
	var mask_2_graphics_30 = new cjs.Graphics().p("EADcBG8MAAAgu4MAiEAAAMAAAAu4g");
	var mask_2_graphics_31 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_2_graphics_32 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_2_graphics_33 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_2_graphics_34 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_2_graphics_35 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_2_graphics_36 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_2_graphics_37 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_2_graphics_38 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_2_graphics_39 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_2_graphics_40 = new cjs.Graphics().p("EgM9BG8MAAAgu4MAiDAAAMAAAAu4g");

	this.timeline.addTween(cjs.Tween.get(mask_2).to({graphics:null,x:0,y:0}).wait(30).to({graphics:mask_2_graphics_30,x:240.025,y:454.05}).wait(1).to({graphics:mask_2_graphics_31,x:350.025,y:758.075}).wait(1).to({graphics:mask_2_graphics_32,x:329.025,y:758.075}).wait(1).to({graphics:mask_2_graphics_33,x:308.025,y:758.075}).wait(1).to({graphics:mask_2_graphics_34,x:287.025,y:758.075}).wait(1).to({graphics:mask_2_graphics_35,x:266.025,y:758.075}).wait(1).to({graphics:mask_2_graphics_36,x:245.025,y:758.075}).wait(1).to({graphics:mask_2_graphics_37,x:224.025,y:758.075}).wait(1).to({graphics:mask_2_graphics_38,x:203.025,y:758.075}).wait(1).to({graphics:mask_2_graphics_39,x:182.025,y:758.075}).wait(1).to({graphics:mask_2_graphics_40,x:135.025,y:454.05}).wait(21));

	// Purple
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#BB9DDA").s().p("AvyJCIfl/gIAANgI/lfdg");
	this.shape_2.setTransform(157.225,758.9);
	this.shape_2._off = true;

	var maskedShapeInstanceList = [this.shape_2];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask_2;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(30).to({_off:false},0).wait(31));

	// pinkmask (mask)
	var mask_3 = new cjs.Shape();
	mask_3._off = true;
	var mask_3_graphics_20 = new cjs.Graphics().p("EgRBA3VMAAAgu5MAiDAAAMAAAAu5g");
	var mask_3_graphics_21 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_3_graphics_22 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_3_graphics_23 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_3_graphics_24 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_3_graphics_25 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_3_graphics_26 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_3_graphics_27 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_3_graphics_28 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_3_graphics_29 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_3_graphics_30 = new cjs.Graphics().p("EgNHA3VMAAAgu5MAiDAAAMAAAAu5g");

	this.timeline.addTween(cjs.Tween.get(mask_3).to({graphics:null,x:0,y:0}).wait(20).to({graphics:mask_3_graphics_20,x:-56.975,y:354.05}).wait(1).to({graphics:mask_3_graphics_21,x:-35.375,y:558.075}).wait(1).to({graphics:mask_3_graphics_22,x:-13.775,y:558.075}).wait(1).to({graphics:mask_3_graphics_23,x:7.825,y:558.075}).wait(1).to({graphics:mask_3_graphics_24,x:29.425,y:558.075}).wait(1).to({graphics:mask_3_graphics_25,x:51.025,y:558.075}).wait(1).to({graphics:mask_3_graphics_26,x:72.625,y:558.075}).wait(1).to({graphics:mask_3_graphics_27,x:94.225,y:558.075}).wait(1).to({graphics:mask_3_graphics_28,x:115.825,y:558.075}).wait(1).to({graphics:mask_3_graphics_29,x:137.425,y:558.075}).wait(1).to({graphics:mask_3_graphics_30,x:134.025,y:354.05}).wait(31));

	// Pink
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#ED96A4").s().p("AvypCIAAtgIflflIAANgg");
	this.shape_3.setTransform(157.175,556.375);
	this.shape_3._off = true;

	var maskedShapeInstanceList = [this.shape_3];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask_3;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(20).to({_off:false},0).wait(41));

	// bluemask (mask)
	var mask_4 = new cjs.Shape();
	mask_4._off = true;
	var mask_4_graphics_10 = new cjs.Graphics().p("EADcAntMAAAgu4MAiEAAAMAAAAu4g");
	var mask_4_graphics_11 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_4_graphics_12 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_4_graphics_13 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_4_graphics_14 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_4_graphics_15 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_4_graphics_16 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_4_graphics_17 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_4_graphics_18 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_4_graphics_19 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_4_graphics_20 = new cjs.Graphics().p("EgM9AntMAAAgu4MAiDAAAMAAAAu4g");

	this.timeline.addTween(cjs.Tween.get(mask_4).to({graphics:null,x:0,y:0}).wait(10).to({graphics:mask_4_graphics_10,x:240.025,y:254.05}).wait(1).to({graphics:mask_4_graphics_11,x:350.025,y:358.075}).wait(1).to({graphics:mask_4_graphics_12,x:329.025,y:358.075}).wait(1).to({graphics:mask_4_graphics_13,x:308.025,y:358.075}).wait(1).to({graphics:mask_4_graphics_14,x:287.025,y:358.075}).wait(1).to({graphics:mask_4_graphics_15,x:266.025,y:358.075}).wait(1).to({graphics:mask_4_graphics_16,x:245.025,y:358.075}).wait(1).to({graphics:mask_4_graphics_17,x:224.025,y:358.075}).wait(1).to({graphics:mask_4_graphics_18,x:203.025,y:358.075}).wait(1).to({graphics:mask_4_graphics_19,x:182.025,y:358.075}).wait(1).to({graphics:mask_4_graphics_20,x:135.025,y:254.05}).wait(41));

	// Blue
	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#85C1D3").s().p("AvyJCIfl/gIAANgI/lfcg");
	this.shape_4.setTransform(157.225,354.3);
	this.shape_4._off = true;

	var maskedShapeInstanceList = [this.shape_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask_4;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape_4).wait(10).to({_off:false},0).wait(51));

	// greenmask (mask)
	var mask_5 = new cjs.Shape();
	mask_5._off = true;
	var mask_5_graphics_0 = new cjs.Graphics().p("AxBX6MAAAgu3MAiDAAAMAAAAu3g");
	var mask_5_graphics_1 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_5_graphics_2 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_5_graphics_3 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_5_graphics_4 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_5_graphics_5 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_5_graphics_6 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_5_graphics_7 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_5_graphics_8 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_5_graphics_9 = new cjs.Graphics().p("AxBXcMAAAgu3MAiDAAAMAAAAu3g");
	var mask_5_graphics_10 = new cjs.Graphics().p("AtHX6MAAAgu3MAiDAAAMAAAAu3g");

	this.timeline.addTween(cjs.Tween.get(mask_5).to({graphics:mask_5_graphics_0,x:-56.975,y:153.05}).wait(1).to({graphics:mask_5_graphics_1,x:-35.375,y:156.075}).wait(1).to({graphics:mask_5_graphics_2,x:-13.775,y:156.075}).wait(1).to({graphics:mask_5_graphics_3,x:7.825,y:156.075}).wait(1).to({graphics:mask_5_graphics_4,x:29.425,y:156.075}).wait(1).to({graphics:mask_5_graphics_5,x:51.025,y:156.075}).wait(1).to({graphics:mask_5_graphics_6,x:72.625,y:156.075}).wait(1).to({graphics:mask_5_graphics_7,x:94.225,y:156.075}).wait(1).to({graphics:mask_5_graphics_8,x:115.825,y:156.075}).wait(1).to({graphics:mask_5_graphics_9,x:137.425,y:156.075}).wait(1).to({graphics:mask_5_graphics_10,x:134.025,y:153.05}).wait(51));

	// Green
	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#C6DD92").s().p("AvypCIAAtgIflflIAANgg");
	this.shape_5.setTransform(157.175,152.275);

	var maskedShapeInstanceList = [this.shape_5];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask_5;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape_5).wait(61));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,258.3,1306);
// library properties:
lib.properties = {
	id: 'C727097938164B9EBCAFFCBFB8DACE79',
	width: 318,
	height: 1318,
	fps: 24,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['C727097938164B9EBCAFFCBFB8DACE79'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;